import { useContractRead } from "wagmi"
import { type Address } from "viem"
import { useMemo } from "react"

import { BinaryEligibilityOracleEarningPowerCalculator__factory as factory } from "@/contracts/bindings/factories/BinaryEligibilityOracleEarningPowerCalculator__factory"

type UseDelegateeEligibilityThresholdScoreParams = {
  contractAddress?: Address
  chainId?: number
  defaultValue?: number
}

type UseDelegateeEligibilityThresholdScoreReturn = {
  thresholdScore: number | undefined
  isLoading: boolean
  isError: boolean
}

export const useDelegateeEligibilityThresholdScore = ({
  contractAddress,
  chainId,
  defaultValue,
}: UseDelegateeEligibilityThresholdScoreParams): UseDelegateeEligibilityThresholdScoreReturn => {
  const { data, isLoading, isError } = useContractRead({
    address: contractAddress as Address,
    abi: factory.abi,
    functionName: "delegateeEligibilityThresholdScore",
    chainId,
    enabled: Boolean(contractAddress),
  })

  const thresholdScore = useMemo(() => {
    if (!data) return defaultValue ?? undefined

    return Number(data)
  }, [data, defaultValue])

  return {
    thresholdScore,
    isLoading,
    isError,
  }
}
